import {
  GET_GOVERNORATES,
  GET_GOVERNORATES_SUCCESS,
  GET_GOVERNORATES_ERROR,
  ADD_GOVERNORATE,
  ADD_GOVERNORATE_SUCCESS,
  ADD_GOVERNORATE_ERROR,
  GET_GOVERNORATE,
  GET_GOVERNORATE_SUCCESS,
  GET_GOVERNORATE_ERROR,
  UPDATE_GOVERNORATE,
  UPDATE_GOVERNORATE_SUCCESS,
  UPDATE_GOVERNORATE_ERROR,
  DELETE_GOVERNORATE,
  DELETE_GOVERNORATE_SUCCESS,
  DELETE_GOVERNORATE_ERROR,
  TOGGLE_GOVERNORATE_MODAL,
  GET_GOVERNORATES_SELECT_LIST,
  GET_GOVERNORATES_SELECT_LIST_SUCCESS,
  GET_GOVERNORATES_SELECT_LIST_ERROR,
} from "./actionTypes";

export const getGovernorates = (request) => {
  return {
    type: GET_GOVERNORATES,
    payload: { request },
  };
};

export const getGovernoratesSuccess = (governorates) => {
  return {
    type: GET_GOVERNORATES_SUCCESS,
    payload: governorates,
  };
};

export const getGovernoratesError = (message) => {
  return {
    type: GET_GOVERNORATES_ERROR,
    payload: message,
  };
};

export const addGovernorate = (request) => {
  return {
    type: ADD_GOVERNORATE,
    payload: { request },
  };
};

export const addGovernorateSuccess = () => {
  return {
    type: ADD_GOVERNORATE_SUCCESS,
  };
};

export const addGovernorateError = (error) => {
  return {
    type: ADD_GOVERNORATE_ERROR,
    payload: error,
  };
};

export const getGovernorate = (id) => {
  return {
    type: GET_GOVERNORATE,
    payload: { id },
  };
};

export const getGovernorateSuccess = (customer) => {
  return {
    type: GET_GOVERNORATE_SUCCESS,
    payload: customer,
  };
};

export const getGovernorateError = (message) => {
  return {
    type: GET_GOVERNORATE_ERROR,
    payload: message,
  };
};

export const updateGovernorate = (request) => {
  return {
    type: UPDATE_GOVERNORATE,
    payload: { request },
  };
};

export const updateGovernorateSuccess = () => {
  return {
    type: UPDATE_GOVERNORATE_SUCCESS,
  };
};

export const updateGovernorateError = (error) => {
  return {
    type: UPDATE_GOVERNORATE_ERROR,
    payload: error,
  };
};

export const deleteGovernorate = (id) => {
  return {
    type: DELETE_GOVERNORATE,
    payload: { id },
  };
};

export const deleteGovernorateSuccess = () => {
  return {
    type: DELETE_GOVERNORATE_SUCCESS,
  };
};

export const deleteGovernorateError = (error) => {
  return {
    type: DELETE_GOVERNORATE_ERROR,
    payload: error,
  };
};

export const getGovernoratesSelectList = () => {
  return {
    type: GET_GOVERNORATES_SELECT_LIST,
  };
};

export const getGovernoratesSelectListSuccess = (selectList) => {
  return {
    type: GET_GOVERNORATES_SELECT_LIST_SUCCESS,
    payload: selectList,
  };
};

export const getGovernoratesSelectListError = (error) => {
  return {
    type: GET_GOVERNORATES_SELECT_LIST_ERROR,
    payload: error,
  };
};

export const toggleGovernorateModalAction = () => {
  return {
    type: TOGGLE_GOVERNORATE_MODAL,
  };
};
